var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxBxsPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06979 20.5281L18.75 10.8479L14.1521 6.24999L4.47188 15.9302C4.33861 16.0636 4.24394 16.2306 4.19792 16.4135L3.125 21.875L8.58542 20.8021C8.76875 20.7562 8.93646 20.6614 9.06979 20.5281ZM21.875 7.7229C22.2656 7.33222 22.485 6.80241 22.485 6.24999C22.485 5.69756 22.2656 5.16775 21.875 4.77707L20.2229 3.12499C19.8322 2.73442 19.3024 2.51501 18.75 2.51501C18.1976 2.51501 17.6678 2.73442 17.2771 3.12499L15.625 4.77707L20.2229 9.37499L21.875 7.7229Z",
    fill: "#041018"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBxsPencil);
export default __webpack_public_path__ + "static/media/bx_bxs-pencil.cdc4ddea.svg";
export { ForwardRef as ReactComponent };